<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Comunicare attraverso i social.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Buona parte della nostra
    <span class="underline-p"
      >comunicazione quotidiana avviene attraverso i social</span
    >
    (Instagram, Tik Tok, Twitter, Facebook, Snapchat, YouTube, blog e forum...).
    Ma come comunicare attraverso questi canali in modo sano ed efficace? Quali
    sono le differenze tra la comunicazione scritta e quella per immagini?
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/phone-2.png"
        alt="telefono"
       
        class="phone-2"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    I lati positivi della comunicazione digitale.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    La conoscenza degli aspetti positivi legati all’utilizzo dei principali
    social e della comunicazione digitale, ma anche dei possibili rischi a cui
    si va incontro, porta gli alunni a diventare utenti attivi e consapevoli
    degli strumenti che usano ogni giorno.
  </p>
</div>

<div class="fifth container grid">
  <h3 class="w-700 blue-50 text-center">
    Utilizzare i social in modo creativo e utile.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Il corso ha lo scopo di portare i ragazzi ad approcciarsi in modo creativo e
    utile ai social più diffusi al momento, ma anche a strumenti di tipo
    editoriale sul web che potranno ritrovare nel loro futuro lavorativo.
  </p>
</div>

<div class="sixth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/phone-3.png"
        alt="telefono"
       
        class="phone-3"
      />
    </div>
  </div>
</div>

<div class="seventh container grid">
  <h3 class="w-700 blue-50 text-center">
    Utilizzare il web in modo consapevole.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Il web può essere usato per migliorarsi, per formarsi, per imparare e per
    condividere. Durante il corso si vuole trasmettere ai ragazzi la
    consapevolezza che ci si trova in un
    <span class="underline-p">luogo reale al 100%</span>.
  </p>
  <p class="w-500 neutral-100 pt-4 px-2 px-xl-5">
    <span class="underline-a"
      >L’obiettivo è evidenziare l’utilità e la facilità</span
    >
    del comunicare sul web (condivisione, divertimento, formazione), ma anche
    far luce su alcuni
    <span class="underline-b">temi sociali e di attualità</span> (cyberbullismo,
    social reputation) che spesso derivano da un utlizzo inconsapevole dei
    social media.
  </p>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
